import React from 'react';
import { shallow, ShallowWrapper, mount } from 'enzyme';
import SmallProfileDisplayList from './SmallProfileDisplayList';
import SmallProfileDisplayItem from './SmallProfileDisplayItem';

const createProps = (numberArray: number[] = []) => ({
  skills: numberArray.map(n => ({
    title: `title: ${n}`,
    label: `label: ${n}`,
  })),
});

let props;
let wrapped: ShallowWrapper;

describe('SmallProfileDisplayList renders no items', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<SmallProfileDisplayList {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });

  it('renders no items', () => {
    expect(wrapped.find(SmallProfileDisplayItem)).toHaveLength(0);
  });
});

describe('SmallProfileDisplayList renders multiple items', () => {
  const n = 5;
  let mounted;
  beforeEach(() => {
    props = createProps(Array.from(Array(n).keys()));
    mounted = mount(<SmallProfileDisplayList {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(mounted.exists()).toBe(true);
  });

  it('renders N items', () => {
    expect(mounted.find(SmallProfileDisplayItem)).toHaveLength(n);
  });
});

describe('SmallProfileDisplayList renders many items', () => {
  const n = 10;
  let mounted;
  beforeEach(() => {
    props = createProps(Array.from(Array(n).keys()));
    mounted = mount(<SmallProfileDisplayList {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(mounted.exists()).toBe(true);
  });

  it('renders N items', () => {
    expect(mounted.find(SmallProfileDisplayItem)).toHaveLength(n);
  });
});
